import { useEffect, useState } from 'react'

import { Workspace } from 'types'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { useIsBlaze } from 'hooks/useIsBlaze'

// DO NOT REORDER
const BLAZE_AVATAR_COLORS = ['#AFA3FF', '#FAE7A3', '#FFC700', '#D6EFB6', '#4DA64B', '#4AA2E1', '#C1DEF8', '#FF8139']

const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('')
const genericFiles = ['Generic1.tsx', 'Generic2.tsx', 'Generic3.tsx']

export const useBlazeAvatar = (letter: string, workspaceId: number | undefined) => {
  const workspaces = useWorkspaces()
  const isBlaze = useIsBlaze()
  const [blazeAvatarColor, setBlazeAvatarColor] = useState<string | undefined>(undefined)
  const [workspace, setWorkspace] = useState<Workspace | undefined>(undefined)
  const [letterFile, setLetterFile] = useState('')

  useEffect(() => {
    const capitalLetter = letter.toUpperCase()
    if (alphabet.includes(capitalLetter)) {
      setLetterFile(`Letter${capitalLetter}.tsx`)
      return
    }

    const genericFileIndex = // If setting generic file, set it systematically, so it doesn't change
      !!workspace && typeof workspace?.avatar_color == 'number' ? Math.floor(workspace.avatar_color / 3) : 0

    setLetterFile(genericFiles[genericFileIndex] || 'Generic1.tsx')
  }, [letter, setLetterFile, workspace])

  useEffect(() => {
    if (typeof workspace?.avatar_color == 'number') {
      setBlazeAvatarColor(BLAZE_AVATAR_COLORS[workspace.avatar_color])
      return
    }

    setBlazeAvatarColor(undefined)
  }, [workspace?.avatar_color])

  useEffect(() => {
    if (isBlaze && workspaceId) {
      const foundWorkspace = workspaces.find((w) => w.id === workspaceId)
      setWorkspace(foundWorkspace)
      return
    }

    setWorkspace(undefined)
  }, [isBlaze, workspaceId, workspaces])

  return { blazeAvatarColor, letterFile }
}
